import { render, staticRenderFns } from "./AiCarList.vue?vue&type=template&id=c51a216e&scoped=true&"
import script from "./AiCarList.vue?vue&type=script&lang=js&"
export * from "./AiCarList.vue?vue&type=script&lang=js&"
import style0 from "./AiCarList.vue?vue&type=style&index=0&id=c51a216e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a216e",
  null
  
)

export default component.exports